import { render, staticRenderFns } from "./BasicInfo.template.vue?vue&type=template&id=76240d57&scoped=true&"
var script = {}
import style0 from "./BasicInfo.template.vue?vue&type=style&index=0&id=76240d57&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76240d57",
  null
  
)

export default component.exports